const translations = {
  "en": {
    "Back": "Back",
    "Cancel": "Cancel",
    "Search Stock / Crypto": "Search Stock / Crypto"
  },
  "zh-tw": {
    "Back": "返回",
    "Cancel": "取消",
    "Search Stock / Crypto": "搜尋股票 / 加密貨幣"
  }
};

export default translations;
